<script setup lang="ts">
withDefaults(defineProps<{ count?: number }>(), {
  count: 5,
});
</script>

<template>
  <div v-for="i in 3" :key="i" class="skeleton-statement">
    <ui-skeleton v-for="n in count" :key="n" height="24px" class="figure ob-mb-md" />
  </div>
</template>
<style scoped lang="scss">
.skeleton-statement {
  border-bottom: 1px solid $gray-100;
  margin-bottom: 40px;
  margin-top: 16px;
}
</style>
